import { useCallback } from "react";
import { BzModal, BzModalBody, BzModalHeader, BzModalTitle } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row } from "react-bootstrap";
import { clearOptionChain, updateLegDataForOptionChain } from "../../redux/actions/optionChain";
import { handleModal } from "../../redux/actions/modals";
import OptionChainGrid from "../OptionChain/OptionChainGrid";
import { sendTouchlineRequest } from "../../apis/web_socket";

function OptionChainModal() {

    const dispatch = useDispatch();
    const modal = useSelector(state => state.modals.modals);
    const objOptionChainPayload = useSelector(state => state?.optionChain?.objOptionChainPayload);
    const objScripsRequested = useSelector(state => state?.optionChain?.objScripsRequested);

    /*
    Below function unsubscribes visibleROws of optionChain rows before closing model
    */
    const unsubScribOptionChainData = useCallback(() => {
        if (Object?.keys(objScripsRequested)?.length > 0) {
            let arrDataToUnsubScribe = Object?.keys(objScripsRequested)?.map((eachToken) => {
                return { exchangeId: Number(eachToken?.split("_")[0]), token: Number(eachToken?.split("_")[1]), isSubscribe: false };
            });
            sendTouchlineRequest(arrDataToUnsubScribe);
        }
    }, [objScripsRequested]);

    const onHide = useCallback(() => {
        unsubScribOptionChainData();
        dispatch(clearOptionChain());
        dispatch(updateLegDataForOptionChain())
        dispatch(handleModal([{ 'OPTION_CHAIN': false }]));
    }, [dispatch, unsubScribOptionChainData]);





    return (
        <BzModal className='modal-scripinfo' size={'xl'} show={modal['OPTION_CHAIN']} onHide={onHide} disableEscapeKey={true} centered>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-self-center'>
                            <BzModalTitle className='font-medium font-size4 color-text'>Option Chain</BzModalTitle>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div className='icon-16 icon-close icon-dark ms-3' onClick={onHide}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0 bdr-btm pb-3'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size4 color-text text-uppercase me-2'>{objOptionChainPayload?.symbol}</div>
                            <div class="chips-wrap">
                                <div class="exchange-chip">{objOptionChainPayload?.exchange}</div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='g-0'>
                        <Col>
                            <OptionChainGrid />
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
        </BzModal>
    );
}

export default OptionChainModal;